/**
 * AP-Status „Erledigt" und Fortschritt (PHQ-87): Erledigt bedeutet immer 100 %.
 * Wird ein erledigtes AP wieder geöffnet, bleibt der Fortschritt nicht auf 100 %
 * stehen — sonst wäre „In Arbeit / 100 %" ein widersprüchlicher Zustand.
 */
export const AP_DONE_STATUS = 'Erledigt';

/** Fortschritt, der zu einem Statuswechsel passt (prevStatus = Status vor der Änderung). */
export function progressForStatus(status: string, prevStatus: string | null, progress: number): number {
  if (status === AP_DONE_STATUS) return 100;
  if (prevStatus === AP_DONE_STATUS && progress >= 100) return 99;
  return progress;
}

/** Anzeige-Fortschritt: ein erledigtes AP zeigt immer 100 %, auch bei Altdaten mit anderem Wert. */
export function displayProgress(status: string, progress: number): number {
  return status === AP_DONE_STATUS ? 100 : progress;
}
